module.exports = __webpack_public_path__ + "img/img6.d2821242.png";